import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { processSteps } from '../data/reviews';
import { site } from '../data/site';
export function ContactPage() {
  return <>
      <PageHero crumbs={[{
      label: 'Contact'
    }]} title={<>
            Contact <span className="text-brand" data-id="element-463" data-mp="1lqtbcdu5lo38">Home Repair MD</span>
          </>} intro="Call us or send a quick quote request. Tell us what needs fixing and we’ll get back to you with a free quote." formTitle="Request a free quote" data-id="element-462" data-mp="1qout8vfufhd4" />

      <section className="bg-white py-20 lg:py-24" data-id="element-464" data-mp="17r0nqrdxbnzh">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[1fr_1fr] lg:gap-20 lg:px-8" data-id="element-465" data-mp="17slgcbgogwup">
          <div data-id="element-466" data-mp="12xpd0f5zqn2a">
            <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-ink sm:text-5xl" data-id="element-467" data-mp="fa7s93l58p8t">
              Reach us <span className="text-brand" data-id="element-468" data-mp="abms145w65kd">directly</span>
            </h2>
            <dl className="mt-8 divide-y divide-line border-y border-line" data-id="element-469" data-mp="15ff3lvimw764">
              <div className="flex items-start gap-4 py-6" data-id="element-470" data-mp="15f6t2a9zhdy3">
                <PhoneIcon className="mt-1 h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-471" data-mp="19fyzywvdv6r7" />
                <div data-id="element-472" data-mp="1e7h2vqgyvhet">
                  <dt className="text-sm font-semibold text-ink-muted" data-id="element-473" data-mp="1e91zdlmudafb">Phone</dt>
                  <dd data-id="element-474" data-mp="1j5sb5wrm5jux">
                    <a href={site.phoneHref} className="font-display text-3xl font-bold text-ink hover:text-brand" data-id="element-475" data-mp="1j6bvfk4qkkc4">
                      {site.phone}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex items-start gap-4 py-6" data-id="element-476" data-mp="vh92hg4nj52b">
                <MapPinIcon className="mt-1 h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-477" data-mp="vfo9vw1wdw73" />
                <div data-id="element-478" data-mp="10hx4ewuf56bb">
                  <dt className="text-sm font-semibold text-ink-muted" data-id="element-479" data-mp="10e9avxoz4jwl">Based in</dt>
                  <dd className="font-display text-2xl font-bold text-ink" data-id="element-480" data-mp="26vwhwd03lzq5">{site.location}</dd>
                </div>
              </div>
            </dl>
            <h3 className="mt-10 font-display text-xl font-bold uppercase text-ink" data-id="element-481" data-mp="1m6u52tagwdh6">Areas we serve</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-482" data-mp="1h8scnhr5j1t1">
              {site.serviceAreas.map(a => <li key={a} className="font-medium text-ink-muted" data-id="element-483" data-mp="1w4i2jqzgjz31">
                  {a}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-canvas p-8 sm:p-10" data-id="element-484" data-mp="13gvnnmks580v">
            <h2 className="font-display text-3xl font-bold uppercase text-ink" data-id="element-485" data-mp="13hdufd52j4n1">What happens next</h2>
            <ol className="mt-6" data-id="element-486" data-mp="yjm0kdkv58g7">
              {processSteps.map((s, i) => <li key={s.title} className="relative flex gap-5 pb-7 last:pb-0" data-id="element-487" data-mp="1d7gutyeirkve" data-mpi={i}>
                  {i < processSteps.length - 1 && <span className="absolute left-5 top-11 h-[calc(100%-2.75rem)] w-px bg-line" aria-hidden="true" data-id="element-488" data-mp="18e467o9ube2n" />}
                  <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ink font-display text-xl font-bold text-white" data-id="element-489" data-mp="frt4296l553q">
                    {i + 1}
                  </span>
                  <div data-id="element-490" data-mp="2w5v9n3ejjw7r">
                    <p className="font-display text-xl font-bold text-ink" data-id="element-491" data-mp="2w64zmqzl63dg">{s.title}</p>
                    <p className="mt-1 text-ink-muted" data-id="element-492" data-mp="2hh8kk9z43q3c">{s.text}</p>
                  </div>
                </li>)}
            </ol>
          </div>
        </div>
      </section>
    </>;
}